<template>
    <table class="table rate-table">
        <thead>
        <tr>
            <th colspan="2">Rental Information</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td width="35%"><strong>Rental Location:</strong></td>
            <td >{{ config.site_name }}</td>
        </tr>
        <tr v-if="reservation.date_pickup!==null && reservation.date_return!==null">
            <td><strong>Rental Dates:</strong></td>
            <td>{{ rental_dates_formatted }}</td>
        </tr>
        <template v-if="(!$store.state.model.reservation.group_link_id) && do_not_show_price_on_checkout!=1 && !($store.state.model.reservation._type=='advance' && !$store.state.model.reservation.is_seasonal && no_priceing_checkouts==1)">
            <tr v-if="!is_prepay">
                <td><strong>Ski Rental<span v-if="reservation.date_pickup!==null && reservation.date_return!==null"> ({{ rental_timespan }})</span>:</strong></td>
                <td v-if="frontend_view_folder=='frontend.winterpark'">{{ _money(toalPriceWithoutDiscount) }}</td>
                <td v-else>
                    <span v-if="showPriceWithoutDiscount">
                        {{ _money(cost.packages_price_without_discounts) }}
                        <span v-if="$store.state.resources.config.module_type == 'module_19' && getNoChargeOnSundayMessage() !== ''" class="error--text">
                            ({{ getNoChargeOnSundayMessage() }}).
                        </span>
                    </span>
                    <span v-else>
                        {{ _money(cost.total_packages_price) }}
                        <span v-if="cost.discount && cost.discount > 0" class='error--text'>(-{{cost.discount+'%'}} Discount)</span>
                        <span v-if="$store.state.resources.config.module_type == 'module_19' && getNoChargeOnSundayMessage() !== ''" class="error--text">
                            ({{ getNoChargeOnSundayMessage() }}).
                        </span>
                    </span>
                </td>
            </tr>
            <tr v-if="!is_prepay">
                <td><strong>Add-on Total:</strong>
                </td>
                <td>
                    <span v-if="showPriceWithoutDiscount">
                        {{ _money(cost.addons_price_without_discounts) }}
                        <v-btn
                            icon
                            @click.prevent="showAddonsModal = true"
                            class="ml-2"
                        >
                            <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                    </span>
                    <span v-else>{{ _money(cost.total_addon_price) }}</span>
                </td>
            </tr>
            <tr v-if="is_buddy_service_enabled && cost.total_addon_price_buddy_insurance &&  !is_prepay">
                <td><strong>Buddy Price:</strong></td>
                <td>{{ _money(cost.total_addon_price_buddy_insurance) }}</td>
            </tr>
            <tr  v-if="!is_prepay && cost.special_days_amount && $store.state.resources.config.module_type != 'module_19'">
                <td><strong>Special period increase ( {{ cost.special_period_days_count }} Days):</strong></td>
                <td>{{ _money(cost.special_days_amount) }}</td>
            </tr>
            <template v-if="!showPriceWithoutDiscount">
                <tr  v-if="!is_prepay">
                    <td><strong>Sub Total:</strong></td>
                    <td v-if="frontend_view_folder=='frontend.winterpark'">{{ _money(toalPriceWithoutDiscount + cost.total_addon_price) }}</td>
                    <td v-else>{{ _money(cost.sub_total) }}</td>
                </tr>
                <tr  v-else>
                    <td><strong>Sub Total:</strong></td>
                    <td>{{ total_without_discount }}</td>
                </tr>
            </template>
            <template v-if="!reservation.is_delivery || (reservation.is_delivery && config.remove_from_front_end_discount =='0')">
                <template v-if="reservation.is_delivery && config.remove_from_front_end_discount=='0' && cost.discount!==0">
                    <tr>
                        <td><strong>Discount:</strong></td>
                        <td class="red--text">{{ _money(cost.advance_discount) }}</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-if="!is_prepay && cost.book_me_discount && cost.book_me_discount.discount > 0">
                        <td><strong>{{ cost.book_me_discount.name }} Discount({{ cost.book_me_discount.percentage }}%):</strong>
                        </td>
                        <td class="red--text">{{ _money(cost.book_me_discount.discount) }}</td>
                    </tr>
                    <tr v-else-if="!is_prepay && cost.saved_by_coupon > 0">
                        <td><strong>Discount ( {{ cost.coupon_info.name }} {{ cost.coupon_info.discount }} ):</strong></td>
                        <td class="red--text">{{ _money(cost.saved_by_coupon) }}</td>
                    </tr>
                    <tr v-else-if="!is_prepay && cost.advance_discount > 0 && (frontend_view_folder == 'frontend.demo' && $store.state.resources.config.module_type == 'module_1')">
                        <td><strong>Discount:
                            <span v-if="cost.advance_discount_days_count > 0">
                                ({{ cost.discount }}% for {{ cost.advance_discount_days_count }} {{ cost.advance_discount_days_count > 1 ? 'Days' : 'Day' }})
                            </span>
                            <span v-else-if="cost.discount > 0">
                                ( {{cost.discount}}% )
                            </span>
                        </strong></td>
                        <td class="red--text">{{ _money(cost.advance_discount) }}</td>
                    </tr>
                    <tr v-else-if="!is_prepay && cost.advance_discount > 0 && (config.module_type_enabled != 0 && (config.module_type == 'module_11' || config.module_type == 'module_15'))">
                        <td><strong>Discount:
                            <span>
                                ( {{cost.discount}}% )
                            </span>
                        </strong></td>
                        <td class="red--text">{{ _money(cost.advance_discount) }}</td>
                    </tr>
                    <tr v-else-if="is_prepay && prepay_discount != '$0.00'">
                        <td><strong>Discount:</strong></td>
                        <td class="red--text">{{ prepay_discount }}</td>
                    </tr>
                    <tr v-else-if="discountType=='percentage' && frontend_view_folder=='frontend.winterpark'">
                        <td><strong>Discount:</strong></td>
                        <td class="red--text">{{ _money(toalPriceWithoutDiscount - cost.total_packages_price) }}</td>
                    </tr>
                    <tr v-else-if="discountType=='fix_amount' && frontend_view_folder=='frontend.winterpark'">
                        <td><strong>Discount:</strong></td>
                        <td class="red--text">{{ _money(fixDiscount) }}</td>
                    </tr>
                </template>
            </template>
            <template v-if="showPriceWithoutDiscount">
                <tr  v-if="!is_prepay">
                    <td><strong>Sub Total:</strong></td>
                    <td v-if="frontend_view_folder=='frontend.winterpark'">{{ _money(toalPriceWithoutDiscount + cost.total_addon_price) }}</td>
                    <td v-else>{{ _money(cost.sub_total) }}</td>
                </tr>
                <tr  v-else>
                    <td><strong>Sub Total:</strong></td>
                    <td>{{ total_without_discount }}</td>
                </tr>
            </template>

            <template v-if="is_international_canadian">
                <tr>
                    <td><strong>Tax: ( PST: {{sales_tax_pst}}% )</strong></td>
                    <td>{{ _money(cost.pst_tax_amount) }}</td>
                </tr>
                <tr>
                    <td><strong>Tax: ( GST: {{sales_tax_gst}}% )</strong></td>
                    <td>{{ _money(cost.gst_tax_amount) }}</td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td>
                        <strong>
                            Taxes: <span v-if="!is_prepay">( {{  cost.tax_percent }}% )</span><span v-else>( {{  prepay_tax_percent }}% )</span>
                        </strong>
                    </td>
                    <td v-if="!is_prepay">{{ _money(cost.tax_amount) }}</td>
                    <td v-else>{{ prepay_sales_tax }}</td>
                </tr>
            </template>
            <tr v-if="parseInt(config.special_fee_at_checkout) == 1">
                <td><strong>{{config.special_fee_label}}:</strong></td>
                <td v-if="!is_prepay">{{ _money(cost.special_fee) }}</td>
                <td v-else>{{ _money(prepay_special_fee) }}</td>
            </tr>
            <tr v-if="!is_prepay">
                <td><strong>Total Cost<span v-if="!isNaN(rental_timespan)"> ({{ rental_timespan }})</span>:</strong></td>
                <td>{{ _money(cost.total_price) }}</td>
            </tr>
            <tr v-else>
                <td><strong>Total To Be Paid:</strong></td>
                <td>{{ _money(prepay_total_price) }}</td>
            </tr>
        </template>
        </tbody>

        <v-dialog v-model="showAddonsModal" max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="headline">Add-on Details</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showAddonsModal = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="text-left">Add-on</th>
                                <th class="text-left">Price</th>
                                <th class="text-left">Coupon Discount</th>
                                <th class="text-left">Taxable</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(addon, index) in selectedAddons" :key="index">
                                <td>{{ addon.title }}</td>
                                <td>{{ addon.price }}</td>
                                <td>{{ addon.discountable ? 'Yes' : 'No' }}</td>
                                <td>{{ addon.taxable ? 'Yes' : 'No' }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>

    </table>
</template>

<script>
import moment from 'moment';
import {formatMoney} from "../../../../plugins/utils";
import {mapGetters} from "vuex";
import UiManagerMixin from "../../../../mixins/UiManagerMixin";

export default {
    name: "RentalInformation",
    mixins  : [UiManagerMixin],
    data() {
        return{
            is_prepay     : false,
            showAddonsModal: false,
        }
    },
    methods:{
        _money(val){
            return formatMoney(val);
        },
        getNoChargeOnSundayMessage() {
            return this.cost.no_charge_on_sunday_message || '';
        },
    },
    computed: {
        rental_dates_formatted() {
            return moment(this.reservation.date_pickup).format(this.$store.state.config.dateFormat)
                + " - " + moment(this.reservation.date_return).format(this.$store.state.config.dateFormat);
        },
        rental_timespan() {
            const days = moment(this.reservation.date_return).diff(moment(this.reservation.date_pickup), 'days') + 1;
            return days + ' Day' + (days > 1 ? 's' : '');
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        reservees(){
            return this.$store.state.model.reservees;
        },
        rental_location() {
            return 'Rezo Ski Demo';
        },
        config() {
            return this.$store.state.resources.config;
        },
        cost() {
            console.log('cost', this.$store.state.model.cost);
            return this.$store.state.model.cost;
        },
        toalPriceWithoutDiscount() {
           let price = this.$store.state.model.cost.total_packages_price;
           console.log(this.cost);
           if(this.config.use_coupons=='1' && this.cost.saved_by_coupon > 0) {
               price = price + this.cost.saved_by_coupon;
           }
            else if(this.discountType=='percentage'){
                price = (100*price)/(100-this.discount);
            }else if(this.discountType=='fix_amount'){
                price =  price + parseInt(this.$store.state.resources.config.fix_discount);
            }
            return price;
        },
        showPriceWithoutDiscount() {
            return parseInt(this.$store.state.resources.config.show_rates_without_discount);
        },
        discount() {
             return parseInt(this.$store.state.resources.config.discount);
        },
        fixDiscount(){
            return parseInt(this.$store.state.resources.config.fix_discount);
        },
        discountType() {
             return this.$store.state.resources.config.discount_type;
        },
        frontend_view_folder(){
            return this.$store.state.resources.config.frontend_view_folder;
        },
        special_fixed_fee() {
            return this.reservees.length * parseFloat(this.config.special_fixed_fee).toFixed(2);
        },
        no_priceing_checkouts() {
            return this.$store.state.resources.config.no_priceing_checkouts;
        },
        is_buddy_service_enabled() {
            let isBuddyChosen = false;
            if(this.$store.state.resources.config.is_buddy_service_enabled) {
                for(let i=0; i < this.$store.state.model.reservees.length; i ++) {
                    if (this.$store.state.model.reservees[i].addons.includes(parseInt(this.$store.state.resources.config.buddy_addon_id))) {
                        isBuddyChosen = true;
                    }
                }
            }

            return isBuddyChosen;
        },
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },
        sales_tax_pst(){
            return parseFloat(this.$store.state.resources.config.sales_tax_pst).toFixed(1);
        },
        sales_tax_gst(){
            return parseFloat(this.$store.state.resources.config.sales_tax_gst).toFixed(1);
        },
        selectedAddons() {
            let addons = [];
            this.$store.state.resources.package_addons.forEach(addon => {
                this.reservees.forEach(reservee => {
                    if (reservee.addons.includes(addon.id)) {
                        addons.push({
                            title: addon.title,
                            price: addon.price,
                            advance_discount: addon.dont_apply_discount == 1 ? false : true,
                            coupon_discount: addon.dont_apply_coupon_discount == 1 ? false : true,
                            taxable: addon.dont_apply_tax == 1 ? false : true
                        });
                    }
                });
            });
            return addons;
        },
        reservees() {
            return this.$store.state.model.reservees;
        },
        ...mapGetters(['total_without_discount', 'prepay_discount', 'prepay_total_price','prepay_special_fee', 'prepay_sales_tax', 'prepay_tax_percent', 'do_not_show_price_on_checkout'])
    },

    mounted() {
        if (window.location.href.includes('prepay')) {
            this.is_prepay = true;
        }
    }
}
</script>

<style scoped>

</style>
